import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

interface IProps {
  image: IPickerOption;
  imageFormat?: 'jpg' | 'jpeg' | 'svg' | 'png';
  selectedImage: string;
  onSelect: (image: string) => void;
}

const LayoutImage: FC<IProps> = ({ imageFormat = 'png', ...props }: IProps): JSX.Element => {
  const imageNamePrefix = useMemo((): string => 'consumer_layout_', []);
  const onSelect = useCallback(() => {
    props.onSelect(String(props.image.value).replace(imageNamePrefix, ''));
  }, [props.image.value, imageNamePrefix]);

  const imageClassName = useMemo((): string => {
    return classNames('layout-image', { 'layout-image_active': props.image.value === imageNamePrefix + props.selectedImage });
  }, [props.image, props.selectedImage, imageNamePrefix]);

  return (
    <div className="layout-image__wrapper">
      <img
        src={formatImagePath(`${String(props.image.value)}.${imageFormat}`)}
        onClick={onSelect}
        alt={`layout-preview-${props.image.label}`}
        className={imageClassName}
      />
      <p className="layout-image__label text-lite-elipsis">{localeStore.t(props.image.label)}</p>
    </div>
  );
};

export default LayoutImage;
